import React, { useEffect, useState } from "react";

const InfiniteScroll = ({ items, loadMoreAmount, threshold, children }) => {
  const [endPosition, setEndPosition] = useState(loadMoreAmount);
  const needsMore = endPosition < items.length;

  useEffect(() => {
    const onScroll = () => {
      if (!needsMore) {
        return;
      }

      const html = document.documentElement;
      const body = document.body;
      const st = "scrollTop";
      const sh = "scrollHeight";
      const percent =
        (html[st] || body[st]) / ((html[sh] || body[sh]) - html.clientHeight);

      if (percent >= threshold) {
        setEndPosition((currentEndPosition) =>
          Math.min(items.length, currentEndPosition + loadMoreAmount)
        );
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [items, loadMoreAmount, threshold, needsMore]);

  return <>{children(items.slice(0, endPosition))}</>;
};

export default InfiniteScroll;
